import React, { Component } from 'react'
import { Button } from 'antd'
import ProposalMilestone from './ProposalMilestone'

class ProposalMilestones extends Component {
  renderMilestone = (milestone, index) => {
    const {
      handleDeleteMilestone,
      handleMilestoneChange,
      moveMilestoneUp,
      moveMilestoneDown
    } = this.props
    return (
      <ProposalMilestone
        key={index}
        index={index}
        milestone={milestone}
        handleDeleteMilestone={handleDeleteMilestone}
        handleMilestoneChange={handleMilestoneChange}
        moveMilestoneUp={moveMilestoneUp}
        moveMilestoneDown={moveMilestoneDown}
      />
    )
  }

  render() {
    const { milestonesDataStructure, handleAddMilestone } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <table className="table table-bordered">
              <thead className="table-primary">
                <tr>
                  <th scope="col">Milestones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="2">
                    <div className="row">
                      <div className="col-6">Description</div>
                      <div className="col-6 text-right">Actions</div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        {milestonesDataStructure &&
                          milestonesDataStructure.map(this.renderMilestone)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 text-right">
                        <Button icon="plus" onClick={() => handleAddMilestone()}>
                          Add Milestone
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default ProposalMilestones



// WEBPACK FOOTER //
// ./src/components/proposal/ProposalMilestones.js